import { API_ChangeMyPassword, API_PutCurrentCustomer } from "../../apiCalls/api.js";
import { useToast } from "vue-toastification";

const toast = useToast();

const state = () => ({
  passwordType: "password",
  eyeIcon: "visibility_off",
  me: {}, 
  chosenCustomer: {} 
});

// getters
const getters = {};

//actions
const actions = {
  toggleShowPassword({ state, commit }) {
    if (state.passwordType == "password") {
      commit("setPasswordType", "text");
      commit("setEyeIcon", "visibility");
    } else {
      commit("setPasswordType", "password");
      commit("setEyeIcon", "visibility_off");
    }
  },
  async handleChangePassword({commit}, parameters) {
    if (parameters.password.length < 8 || parameters.repeatPassword.length < 8) {
      toast.error("Password must exceed 7 characters!");
      return;
    }
    if (parameters.password == parameters.repeatPassword) {
      const dict = {
        Email: localStorage.getItem('username'),
        NewPassword: parameters.password,
        Token: localStorage.getItem('token')
      };

      try {
        const passwordChangeRespone = await API_ChangeMyPassword(dict);
        if (passwordChangeRespone.status == 200) {
          toast.success("Password changed!");
          commit("setEyeIcon", "visibility_off");
        } else {
          toast.error(
            "Password change failed! \r\n\r\n" + passwordChangeRespone.status
          );
        }
      } catch (e) {
        toast.error(
            "Password change failed! \r\n\r\n" + e.message
          );
      }
    } else {
      toast.error("Passwords do not match!");
    }
  },
  async setChosenCustomer({state, commit}, id){ 
    const customer = state.me.Customers.find(x => x.Id === parseInt(id))
    if(customer){
      try{
        const putCurrentCustomerResponse = await API_PutCurrentCustomer(customer.Id);
        if (putCurrentCustomerResponse.status == 200) {
          localStorage.setItem('chosenCustomer', customer.Id)
          commit("setChosenCustomer", customer)
        } else {
          toast.error(
            "Could not change customer! \r\n\r\n" + putCurrentCustomerResponse.status
          );
        }
      }
      catch(e){
        toast.error(
          "Could not change customer! \r\n\r\n" + e.message
        );
      }
    }
  }
};

const mutations = {
  setPasswordType(state, value) {
    state.passwordType = value;
  },
  setEyeIcon(state, value) {
    state.eyeIcon = value;
  }, 
  setMe(state, data){ 
    state.me = data 
  }, 
  setChosenCustomer(state, data){ 
    state.chosenCustomer = data 
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
